import { render, staticRenderFns } from "./UnpaywallJournals.vue?vue&type=template&id=7fb5b016"
import script from "./UnpaywallJournals.vue?vue&type=script&lang=js"
export * from "./UnpaywallJournals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports